"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PyroblastAbilityHandler = exports.PyroblastActorAbilityFactory = exports.PyroblastAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const __2 = require("../..");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class PyroblastAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Pyroblast;
        this.__typeName = "Pyroblast";
    }
}
exports.PyroblastAbilityArgs = PyroblastAbilityArgs;
let PyroblastActorAbilityFactory = class PyroblastActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Pyroblast", "OneEnemies", 3);
    }
};
PyroblastActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Pyroblast")
], PyroblastActorAbilityFactory);
exports.PyroblastActorAbilityFactory = PyroblastActorAbilityFactory;
let PyroblastAbilityHandler = class PyroblastAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Fire", 120)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new __1.BurningEffectArgs("Focus", 10),
                    duration: Duration_1.Duration.Ticks(8),
                    sequence: sequence
                        .push(new __2.InstantVfxStepArgs(new __2.ActorVfxLocationSelector(selectedEnemy, "feet"), "DragonfirePillar"))
                        .pushSequence("sequential")
                });
            },
            onMiss(sequence) {
                sequence.push(new __2.InstantVfxStepArgs(new __2.ActorVfxLocationSelector(selectedEnemy, "random", "behind"), "DragonfirePillar"));
            }
        });
    }
};
PyroblastAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Pyroblast)
], PyroblastAbilityHandler);
exports.PyroblastAbilityHandler = PyroblastAbilityHandler;
